
import React from 'react';
import {Modal, ModalBody} from 'reactstrap';

import Component from '../../components/Component';
import Form from '../../components/form/Form';

export default class CreateDocumentModal extends Component
{

	/**
     * The fields mapping for the form {field1: {type: 'text'}, field2: {type: 'email'}}
     *
     * @var {Object | Array[Object]}
     */
    static FormFields = {
    	path: {
    		label: 'documents.edit.path_label',
    		type: 'file',
    		required: true,
    	},
    	name: {
			label: 'documents.edit.name_label',
			required: true,
		},
		type: {
			label: 'documents.edit.type_label',
			type: 'select',
			required: true,
			options: laravel.document_types,
		},
    };

    onChange(model)
    {
    	if (!model || !model.path || model.name) {
    		return;
    	}

    	let updated = {...model};
    	updated.name = updated.path[0].name.split('.')[0]
    	this.setState({model: updated})
    }

  	render()
  	{
	    return (
	      	<div>
		        <Modal isOpen={this.props.isVisible}
		        	toggle={this.props.toggle}>
		          	<ModalBody>
		          		<div className="flex"
		          			style={{justifyContent: 'space-between', alignItems: 'center'}}>

							<p className="mb-0">{TB.tryTrans('documents.create.title')}</p>

							<button type="button"
								style={{fontSize: 16, padding: 10, textAlign: 'right'}}
								className="btn"
								onClick={this.props.toggle}>
								<i className="fa fa-times-circle"/>
							</button>
						</div>
		          		<Form model={this.state.model}
		          			fields={this.constructor.FormFields}
		          			isDisabled={this.props.isDisabled}
		          			onSubmit={model => {
		          				let normalized = {...model};
		          				normalized.path = normalized.path[0];
		          				this.props.onSubmit(normalized);
		          			}}
		          			onChange={this.onChange.bind(this)}
		          			submitButton={TB.tryTrans('documents.create.submit_button')}/>
		          	</ModalBody>

		        </Modal>
	      	</div>
	    );
  	}
}